import React, { useState, useEffect } from 'react';

const ActivityLED = ({ lastTrigger, isActive, color = '#00E5FF' }) => {
  const [lit, setLit] = useState(false);

  useEffect(() => {
    if (lastTrigger || isActive) {
      setLit(true);
      const timer = setTimeout(() => setLit(false), 100);
      return () => clearTimeout(timer);
    }
  }, [lastTrigger, isActive]);

  return (
    <div
      style={{
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: lit ? color : '#333',
        boxShadow: lit ? `0 0 10px ${color}` : 'none',
        transition: 'background-color 0.05s ease',
        marginRight: '8px'
      }}
    />
  );
};

export default ActivityLED;
